import React from "react";
import "./instruction.css";

export const InstructionContent: React.FC = () => {
  return (
    <div className="content_container">
      The aim of this survey is to provide baseline data to inform the{" "}
      Southampton City Council{" "}
      <strong>Green City (GC) Performance Tracker</strong>, which is being
      developed by the University of Southampton, to measure the success or
      otherwise of the commitments and progress of signatories over the next few
      years. The Environmental template involves the assessment of five main
      themes (criteria) and sub-criteria as set out by Southampton City Council,
      including Sustainable Energy & Carbon Reduction, Delivering Clean Air &
      Quality of Life, Natural Environment, Resource Waste & Water Management{" "}
      and Sustainable Travel. The carbon emission template will require data
      input for scope 1,2 and 3 emissions.
      <br />
      <br />
      Environmental template questions relate to specific items within the
      criteria which is shown on the platform alongside this the rating system
      is shown through a clickable link for each item which provides information
      on the intent and requirement for each item showing the full breakdown of
      how points are awarded.
      <br />
      <br />
      This survey refers to the 2020 calendar year with all data required being
      from this time period, unless otherwise stated.
      <br />
      <br />
      When asked about employees, this refers to staff working directly for the
      organisation of which you would be able to monitor their energy usage, car
      type, etc. in addition you should only count those that you, as an
      organisation, can influence. This same logic applies for everything being
      considered , whereby you should only record data on people, buildings,
      etc. that you have responsibility for and a certain level of control over.
      <br />
      <br />
      We appreciate that this survey is a large undertaking and are willing to
      assist wherever possible, with the platform allowing you to save your
      progress and return at a later date or allow a colleague to log-in and
      enter data.. If you wish to arrange a meeting or phone call, our contacts
      are: Philip Turner (p.a.d.turner@soton.ac.uk) or Mostafa Mahdy
      (M.Mahdy@soton.ac.uk) at the University of Southampton ( 02380 593940 ).
      <br />
      <br />
      Organisations specific data and template responses are held
      confidentially, regardless of whether the final results are made public or
      kept private. The UoS in its academic publications may use anonymised data
      without revealing the names of the organisations. Publications that may
      have anonymised data will be discussed with partners before publication.
      Identities of participating organisations will not be revealed unless
      approved.
    </div>
  );
};
